export default {
  path: 'contact',
  name: 'contact',
  redirect: { name: 'contact.index' },
  children: [
    {
      path: '',
      name: 'contact.index',
      component: () => import('pages/contact/IndexPage.vue'),
    },
    {
      path: 'update',
      name: 'contact.update',
      component: () => import('pages/contact/UpdatePage.vue'),
    },
  ],
}
